import { Guid } from '../model/guid';
import { ensureIsMenuItem, ensureNonSequencedFlowItem } from '@ael/core-api';
import {menuAction} from '../../actions/menuActions';
import {contentItemAction} from '../../actions/contentItemActions';

export interface MenuStartingMessageReducerState {
  startingMessageId: Guid | null;
  dismissed: boolean;
}

const emptyMenuStartingMessageState: MenuStartingMessageReducerState = {
  startingMessageId: null,
  dismissed: true,
};

export function menuStartingMessageReducer(
  state: MenuStartingMessageReducerState = emptyMenuStartingMessageState,
  action: any
): MenuStartingMessageReducerState {
  switch (action.type) {
    case menuAction.SideMenu_SelectedSubmenuItem: {
      ensureIsMenuItem(action.payload.selectedItem);
      const startingMessageId = action.payload.selectedItem.startingMessageId;
      if (startingMessageId) {
        return {
          startingMessageId: startingMessageId,
          dismissed: false,
        };
      }
      return {
        startingMessageId: null,
        dismissed: true,
      };
    }
    case menuAction.SideMenu_SelectNonSequencedFlowItem: {
      ensureNonSequencedFlowItem(action.payload);
      const startingMessageId = action.payload.startingMessageId;
      if (startingMessageId) {
        return {
          startingMessageId: startingMessageId,
          dismissed: false,
        };
      }
      return {
        startingMessageId: null,
        dismissed: true,
      };
    }
    case contentItemAction.MenuItemStartingMessage_Dismissed: {
      return {
        ...state,
        dismissed: true,
      };
    }
    case menuAction.SideMenu_DeselectItem:
    case menuAction.SideMenu_NavigateBack:
    case menuAction.SideMenu_SelectedQuiz:
    case menuAction.SideMenu_SelectedResource:
    case menuAction.SideMenu_SelectSequencedFlowItem:
      return {
        startingMessageId: null,
        dismissed: true,
      };
    default:
      return state;
  }
}
